// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__xmfmy","footerIcon":"Footer_footerIcon__nB+0v","icon":"Footer_icon__BywOg","top":"Footer_top__SsHbq","footerText":"Footer_footerText__m3YCN"};